import { LiteratureName } from "@enums";
export const hintLiterature: LiteratureName[] = [
  LiteratureName.CacheHint1,
  LiteratureName.CacheHint2,
  LiteratureName.ServerOfflineHint,
  LiteratureName.DarkWebRebootHint,
  LiteratureName.PasswordServerHint,
  LiteratureName.TimingServerHint,
  LiteratureName.BinaryServerHint,
  LiteratureName.DogNameHint,
  LiteratureName.FactoryDefaultHint,
  LiteratureName.StasisLinkHint,
  LiteratureName.LabHint,
];
